import * as React from 'react';
import { Tooltip } from 'antd';
export var FeatureDisplayWrapper = function FeatureDisplayWrapper(_ref) {
  var type = _ref.type,
      forwardProps = _ref.forwardProps,
      children = _ref.children;
  var Wrapper;

  switch (type) {
    case 'tooltip':
      // @ts-ignore
      Wrapper = Tooltip;
      break;

    default:
      Wrapper = function Wrapper(_) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, _.children);
      };

  }

  return /*#__PURE__*/React.createElement(Wrapper, forwardProps, children);
};